module.exports = __webpack_public_path__ + "media/25.a79ca9ec.mp3";